import { useEffect } from "react";

/**
 * Set ``document.title`` to a static page name suffixed with the brand
 * product name (WCAG 2.4.2 Page Titled). tilt-admin has no i18n today,
 * so the page name is a literal string.
 *
 * The brand product name is whatever ``useFavicon`` (in AppShell)
 * already wrote to ``document.title`` - we read it back, strip any
 * prior page prefix, and rewrite as ``<page> · <brand>``.
 */
export function usePageTitle(page: string): void {
  useEffect(() => {
    const brand = readBrandName();
    document.title = brand ? `${page} · ${brand}` : page;
  }, [page]);
}

function readBrandName(): string | null {
  if (typeof document === "undefined") return null;
  const current = document.title.trim();
  if (!current) return null;
  // Strip a previous "<page> · <brand>" prefix so titles don't chain
  // across navigations.
  const sep = current.lastIndexOf(" · ");
  if (sep > 0) return current.slice(sep + 3).trim();
  return current;
}
